export enum TypeOfProperty {
    Apartment = 1,
    Terrace = 2,
    PumpHouse = 3,
    SingleHouse = 4,
    Others = 5,
}